export type BootstrapEnv = 'prod' | 'staging' | 'test' | 'dev';

const SUPPORTED_PERIMETERS = ['COMMERCIAL', 'FEDRAMP'] as const;
type AutomationPerimeter = (typeof SUPPORTED_PERIMETERS)[number];

export type StackContext = {
	buildNumber: string;
	staticPrefix: string;
	perimeter: AutomationPerimeter;
};

export const isObjectStackContext = (value: unknown): value is StackContext => {
	if (typeof value !== 'object' || value === null) {
		return false;
	}
	// ignore @typescript-eslint/consistent-type-assertions because we are checking the type of the object
	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	const potentialStackContext = value as StackContext;
	return (
		typeof potentialStackContext.staticPrefix === 'string' &&
		typeof potentialStackContext.buildNumber === 'string' &&
		SUPPORTED_PERIMETERS.includes(potentialStackContext.perimeter)
	);
};
